  
    (function () {
      window.__abMainStarted = true;
      
      // ── Config ────────────────────────────────────────────────────────────────
      var FETCH_TIMEOUT_MS          =  1500;
      var PUBLISH_RETRY_INTERVAL_MS = 50;
      var PUBLISH_RETRY_MAX_ATTEMPTS = 8; // tổng tối đa 400ms
      var HIDE_FAILSAFE_MS          = 1500;
      
      var PAGE_EXPERIMENT_TYPES = {
        'homepage':    ['content'],
        'product':     ['content'],
        'collection':  ['content'],
        'custom_page': ['content'],
      };
      
      // ── Page context — inject từ Shopify Liquid ───────────────────────────────
      var country = window.ShopifyVars.context.country || null;
      var template_suffix = window.ShopifyVars.context.template_suffix || null;
      var currentView     = new URLSearchParams(window.location.search).get('view');
      var ref             = document.referrer && new URL(document.referrer).hostname;
      var referring_domain = (ref && ref !== window.location.hostname) ? ref : null;
      
      // ── Visitor/session identity ──────────────────────────────────────────────
      var visitor_id = localStorage.getItem('ab_visitor_id');
      if (!visitor_id) {
        visitor_id = crypto.randomUUID();
        localStorage.setItem('ab_visitor_id', visitor_id);
      }
      
      var session_id = sessionStorage.getItem('ab_session_id');
      if (!session_id) {
        session_id = crypto.randomUUID();
        sessionStorage.setItem('ab_session_id', session_id);
      }
      
      // ── Helpers ───────────────────────────────────────────────────────────────
      function getDeviceType() {
        var ua = navigator.userAgent.toLowerCase();
        if (/tablet|ipad|playbook|silk/.test(ua)) return 'tablet';
        if (/mobile|iphone|ipod|android|blackberry|mini|windows\sce|palm/.test(ua)) return 'mobile';
        return 'desktop';
      }
      
      function getPageUrl() {
        var path = window.location.pathname.replace(/\/+$/, '');
        return path === '' ? '/' : path;
      }
      
      function getPageUrlFromUrl(url) {
        var path = url.pathname.replace(/\/+$/, '');
        return path === '' ? '/' : path;
      }

      function getContentExperimentCacheKey(targetPageUrl, targetCountry) {
        var resolvedPageUrl = targetPageUrl || pageUrl;
        var resolvedCountry = targetCountry || country || 'unknown';
        return resolvedCountry + '::' + resolvedPageUrl;
      }
      
      function getUTMParam(key) {
        var p = new URLSearchParams(window.location.search);
        var value = p.get(key);
        if (value) {
          localStorage.setItem(key, value);
          return value;
        }
        return localStorage.getItem(key) || null;
      }
      
      function getPageCategory(pageUrl) {
        if (pageUrl === '/')                         return 'homepage';
        if (pageUrl.startsWith('/products'))         return 'product';
        if (pageUrl.startsWith('/collections'))      return 'collection';
        if (pageUrl.startsWith('/pages'))            return 'custom_page';
        return null;
      }
      
      // Tính 1 lần, dùng lại cho cả fetchExperiment + getPageCategory
      var pageUrl    = getPageUrl();
      var deviceType = getDeviceType();
      var utmParams  = {
        utm_source:   getUTMParam('utm_source'),
        utm_medium:   getUTMParam('utm_medium'),
        utm_campaign: getUTMParam('utm_campaign'),
        utm_content:  getUTMParam('utm_content'),
        utm_term:     getUTMParam('utm_term'),
      };
      
      // ── Build experiment data ─────────────────────────────────────────────────
      function buildExperimentData(experiment) {
        return {
          experiment_id:    experiment.experiment_id,
          variant_id:       experiment.variant_id,
          visitor_id:       visitor_id,
          session_id:       session_id,
          country:          country,
          referring_domain: referring_domain,
          fbclid:           getUTMParam('fbclid'),
          gclid:            getUTMParam('gclid'),
          ttclid:           getUTMParam('ttclid'),
          cjevent:          getUTMParam('cjevent'),
          epik:             getUTMParam('epik'),
          utm_source:       utmParams.utm_source,
          utm_medium:       utmParams.utm_medium,
          utm_campaign:     utmParams.utm_campaign,
          utm_content:      utmParams.utm_content,
          utm_term:         utmParams.utm_term,
        };
      }
      
      // ── Anti-flicker ──────────────────────────────────────────────────────────
      function getCachedContentExperiment(targetPageUrl) {
        try {
          var cacheKey = getContentExperimentCacheKey(targetPageUrl);
          var cache = JSON.parse(sessionStorage.getItem('ab_content_experiment_cache') || '{}');
          return cache[cacheKey] || null;
        } catch(e) {
          console.warn('[ABStudio] Failed to read experiment cache:', e);
        }
        
        return null;
      }
      
      function setCachedContentExperiment(data, targetPageUrl) {
        try {
          var cacheKey = getContentExperimentCacheKey(targetPageUrl, data && data.country);
          var cache = JSON.parse(sessionStorage.getItem('ab_content_experiment_cache') || '{}');
          cache[cacheKey] = data;
          sessionStorage.setItem('ab_content_experiment_cache', JSON.stringify(cache));
        } catch(e) {
          console.warn('[ABStudio] Failed to write experiment cache:', e);
        }
      }
      
      function getCachedTemplateSuffix(cachedData) {
        return cachedData ? cachedData.template_suffix : null;
      }
      
      var hideFailsafeTimer = null;

      function revealPage() {
        document.documentElement.classList.remove('ab-prehide');
        var loader = document.getElementById('ab-loader');
        var style = document.getElementById('ab-prehide-style');
        if (loader) loader.remove();
        if (style) style.remove();
        if (window.__abPrehideTimer) {
          clearTimeout(window.__abPrehideTimer);
          window.__abPrehideTimer = null;
        }
      }
      
      
      // ── Fetch experiment theo type ────────────────────────────────────────────
      function fetchExperiment(type, targetPageUrl) {
        return fetch('https://api-custom.medzt.com/active-experiment', {
          method: 'POST',
          signal: AbortSignal.timeout(FETCH_TIMEOUT_MS),
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            query: [
              'query GetActiveExperiment($input: GetActiveExperimentInput!) {',
              '  getActiveExperiment(input: $input) {',
              '    experiment_id',
              '    variant_id',
              '    experiment_type',
              '    variant_data',
              '  }',
              '}'
            ].join('\n'),
            variables: {
              input: {
                page_url:         targetPageUrl || pageUrl,
                visitor_id:       visitor_id,
                device_type:      deviceType,
                experiment_type:  type,
                template_suffix:  template_suffix,
                utm_source:       utmParams.utm_source,
                utm_medium:       utmParams.utm_medium,
                utm_campaign:     utmParams.utm_campaign,
                utm_content:      utmParams.utm_content,
                country:          country,
                referring_domain: referring_domain,
              }
            }
          })
        })
        .then(function(res) {
          if (!res.ok) throw new Error('API error: ' + res.status);
          return res.json();
        })
        .catch(function(err) {
          console.warn('[ABStudio] fetchExperiment(' + type + ') failed:', err);
          return null;
        });
      }
      
      // ── Publish experiment_assigned cho Pixel ─────────────────────────────────
      function publishExperiment(data) {
        function tryPublish() {
          if (!(window.Shopify && window.Shopify.analytics)) return false;
          try {
            Shopify.analytics.publish('abstudio:experiment_assigned', data);
            return true;
          } catch (err) {
            console.warn('[ABStudio] Failed to publish experiment_assigned event:', err);
            return false;
          }
        }
        
        if (tryPublish()) return Promise.resolve(true);
        
        return new Promise(function(resolve) {
          var attempts = 0;
          var retryInterval = setInterval(function () {
            attempts++;
            if (tryPublish()) {
              clearInterval(retryInterval);
              resolve(true);
            } else if (attempts >= PUBLISH_RETRY_MAX_ATTEMPTS) {
              console.warn('[ABStudio] Shopify.analytics not available after retries, giving up.');
              clearInterval(retryInterval);
              resolve(false);
            }
          }, PUBLISH_RETRY_INTERVAL_MS);
        });
      }
      
      // ── Experiment type handlers ──────────────────────────────────────────────
      function handleContentExperiment(experiment, isSkipped) {
        if (isSkipped) {
          var cachedData = getCachedContentExperiment();
          if (cachedData && getCachedTemplateSuffix(cachedData) === currentView) {
            publishExperiment(cachedData);
          }
          revealPage();
          return;
        }
        
        if (!experiment) {
          revealPage();
          return;
        }
        
        var suffix = experiment.variant_data?.template_suffix;
        var data = buildExperimentData(experiment);
        if (suffix === '') {
          // Version A (control) — không redirect nhưng vẫn publish
          setCachedContentExperiment(Object.assign({}, data, {
            template_suffix: suffix,
            page_url: pageUrl
          }));
          publishExperiment(data);
          revealPage();
          return;
        }
        
        if (!suffix) {
          console.warn('[ABStudio] Content experiment missing template_suffix:', experiment);
          revealPage();
          return;
        }
        
        if (currentView !== suffix) {
          var cacheData = Object.assign({}, data, {
            template_suffix: suffix,
            page_url: pageUrl
          });
          setCachedContentExperiment(cacheData);
          var url = new URL(window.location.href);
          url.searchParams.set('view', suffix);
          window.location.replace(url.toString());
          return;
        }
        
        publishExperiment(data);
        revealPage();
      }
      
      var EXPERIMENT_TYPE_HANDLERS = {
        'content': handleContentExperiment,
      };
      
      var EXPERIMENT_SKIP_FETCH = {
        'content': function() {
          return currentView !== null;
        },
      };
      
      var prefetchedContentPages = {};
      
      function getEligibleContentLink(link) {
        if (!link || !link.href || link.target || link.hasAttribute('download')) return null;
        
        var url = new URL(link.href, window.location.href);
        if (url.origin !== window.location.origin || url.searchParams.has('view')) return null;
        
        var targetPageUrl = getPageUrlFromUrl(url);
        if (targetPageUrl === pageUrl) return null;
        if ((PAGE_EXPERIMENT_TYPES[getPageCategory(targetPageUrl)] || []).indexOf('content') === -1) return null;
        
        return {
          url: url,
          page_url: targetPageUrl
        };
      }
      
      function applyCachedViewToLink(link) {
        var target = getEligibleContentLink(link);
        if (!target) return false;
        
        var cachedData = getCachedContentExperiment(target.page_url);
        var cachedTemplateSuffix = getCachedTemplateSuffix(cachedData);
        if (!cachedData) return false;
        if (!cachedTemplateSuffix) return true;
        
        target.url.searchParams.set('view', cachedTemplateSuffix);
        link.href = target.url.toString();
        return true;
      }
      
      function prefetchContentExperiment(link) {
        var target = getEligibleContentLink(link);
        if (!target || prefetchedContentPages[target.page_url]) return;
        
        var cachedData = getCachedContentExperiment(target.page_url);
        if (cachedData) {
          applyCachedViewToLink(link);
          return;
        }
        
        prefetchedContentPages[target.page_url] = true;
        
        fetchExperiment('content', target.page_url).then(function(data) {
          var experiment = data?.data?.getActiveExperiment;
          if (!experiment) return;
          
          var suffix = experiment.variant_data?.template_suffix;
          if (suffix === undefined || suffix === null) return;
          
          setCachedContentExperiment(Object.assign({}, buildExperimentData(experiment), {
            template_suffix: suffix,
            page_url: target.page_url
          }), target.page_url);
          applyCachedViewToLink(link);
        });
      }
      
      function getLinkFromEvent(event) {
        return event.target && event.target.closest && event.target.closest('a[href]');
      }
      
      document.addEventListener('click', function(event) {
        applyCachedViewToLink(getLinkFromEvent(event));
      }, true);
      
      // ── Main flow ─────────────────────────────────────────────────────────────
      var pageCategory   = getPageCategory(pageUrl);
      var experimentTypes = PAGE_EXPERIMENT_TYPES[pageCategory] || [];
      
      if (experimentTypes.length === 0) {
        console.log('[ABStudio] No experiment types for page category: ' + pageCategory);
        revealPage();
        return;
      }
      
      if (currentView === null && experimentTypes.indexOf('content') !== -1) {
        var cachedContentExperiment = getCachedContentExperiment();
        var cachedTemplateSuffix = getCachedTemplateSuffix(cachedContentExperiment);
        if (cachedContentExperiment && cachedTemplateSuffix === '') {
          publishExperiment(cachedContentExperiment);
          revealPage();
          return;
        }
        
        if (cachedContentExperiment && cachedTemplateSuffix) {
          var cachedUrl = new URL(window.location.href);
          cachedUrl.searchParams.set('view', cachedTemplateSuffix);
          window.location.replace(cachedUrl.toString());
          return;
        }
        
      }
      
      Promise.all(experimentTypes.map(function(type) {
        var shouldSkip = EXPERIMENT_SKIP_FETCH[type];
        if (shouldSkip && shouldSkip()) return Promise.resolve({ skipped: true });
        return fetchExperiment(type);
      }))
      .then(function(results) {
        results.forEach(function(data, i) {
          var type       = experimentTypes[i];
          var isSkipped  = data?.skipped === true;
          var experiment = isSkipped ? null : data?.data?.getActiveExperiment;
          
          if (!isSkipped && !experiment) {
            console.log('[ABStudio] No active experiment for type: ' + type);
            revealPage();
            return;
          }
          
          var handler = EXPERIMENT_TYPE_HANDLERS[type];
          if (!handler) return;
          
          handler(experiment, isSkipped);
        });
      })
      .catch(function(err) {
        console.warn('[ABStudio] Main flow failed:', err);
        revealPage();
      });
    })();